/* eslint-disable react/prop-types */
/** @jsx createElement */
// noinspection ES6UnusedImports
import { createElement } from '../../jsx';
import uploadChatAttachment from './common/uploadChatAttachment';
import TransferTargets from './TransferTargets';
import TransferContact from './TransferContact';
import TransferCustomDetails from './TransferCustomDetails';
import TransferConfirmButton from './TransferConfirmButton';
import TransferUploadFile from './TransferUploadFile';
import styles from './styles.less';
import TransferFormError from './TransferFormError';

const extractFormData = function (form, targetId) {
  const result = { targetId, customFields: [] };

  form.querySelectorAll('input:not([disabled]),select:not([disabled])')
    .forEach((input) => {
      const id = input.getAttribute('id');
      switch (id) {
        case 'phone': result.phone = input.value; break;
        case 'email': result.email = input.value; break;
        case 'transfer-target': result.targetId = input.value; break;
        default:
          if (input.name && input.value != null && input.value !== '') {
            result.customFields.push({
              label: input.name,
              value: input.value,
            });
          }
      }
    });
  return result;
};

const uploadAttachments = async function (idToken, chatId, attachments) {
  return Promise.all(attachments.map(
    async (attachment) => uploadChatAttachment(idToken, chatId, attachment),
  ));
};

const handleSubmit = async function (
  event,
  {
    chatId, idToken, targetId, attachments,
  },
  { confirmHandler, errorHandler },
) {
  event.preventDefault();
  try {
    TransferFormError.clearErrors();

    const result = extractFormData(event.target, targetId);
    result.attachments = await uploadAttachments(idToken, chatId, attachments);
    confirmHandler(result);
  } catch (err) {
    errorHandler(err);
  }
};

const TransferForm = function ({
  targetId: defaultTargetId,
  chatId,
  idToken,
  transferTargets,
  transferContactType,
  transferCustomDetails: customDetails,
  userDetails,
  confirmHandler,
  chatControl: {
    translations,
  },
}) {
  const targetId = defaultTargetId || transferTargets[0].id;
  const attachments = [];
  return (
    <li className="wrapper chatMessage agent embeddedServiceLiveAgentStateChatItem guuruContact guuruContainer">
      <div className="chatContent">
        <form
          className={`fieldList agent embeddedServiceLiveAgentStateChatPlaintextMessageDefaultUI plaintextContent guuruForm ${styles.chatTransferForm}`}
          onSubmit={(event) => handleSubmit(event, {
            chatId, idToken, targetId, attachments,
          }, {
            confirmHandler, errorHandler: TransferFormError.showErrors,
          })}
        >
          <TransferTargets
            transferTargets={transferTargets}
            translations={translations}
          />
          <TransferCustomDetails
            customDetails={customDetails}
            targetId={targetId}
          />
          <TransferUploadFile
            translations={translations}
            attachments={attachments}
          />
          <TransferContact
            contactType={transferContactType}
            userDetails={userDetails}
            translations={translations}
          />
          <TransferConfirmButton translations={translations} />
          <TransferFormError translations={translations} />
        </form>
      </div>
      <div className="nameAndTimeContent" />
    </li>
  );
};

export default TransferForm;
